import { withDependencies, type FactoryWithDependencies } from '@wix/thunderbolt-ioc'
import type { ServiceProvider } from '@wix/thunderbolt-symbols'
import { AnchorsDefinition } from '@wix/viewer-service-anchors/definition'
import type { IAnchorsDefinition } from '@wix/viewer-service-anchors/definition'
import { AnchorsService } from '@wix/viewer-service-anchors/implementations'

export const anchorsService: FactoryWithDependencies<ServiceProvider<IAnchorsDefinition, typeof AnchorsService>> =
	withDependencies([], (): ServiceProvider<IAnchorsDefinition, typeof AnchorsService> => {
		return {
			definition: AnchorsDefinition,
			impl: AnchorsService,
			config: {},
		}
	})
